import { useMutation, useQuery, useQueryClient } from '@tanstack/react-query'
import { applyPlan, listRecommendations, planTrip } from '../../shared/api/ai'
import type { AiPlanPreview } from '../../shared/api/ai.http'
import { pointKeys } from '../timeline/usePoints'

export const aiKeys = {
  recommendations: (tripId: string) => ['recommendations', tripId] as const,
}

/** POST /trips/:id/ai/plan — generate a read-only proposal. */
export function usePlanTrip(tripId: string) {
  return useMutation({
    mutationFn: (prompt: string) => planTrip(tripId, prompt),
  })
}

export function useApplyPlan(tripId: string) {
  const qc = useQueryClient()
  return useMutation({ mutationFn: (preview: AiPlanPreview) => applyPlan(tripId, preview),
    onSuccess: () => qc.invalidateQueries({ queryKey: pointKeys.byTrip(tripId) }) })
}

export function useRecommendations(tripId: string | undefined) {
  return useQuery({
    queryKey: aiKeys.recommendations(tripId ?? 'unknown'),
    queryFn: () => listRecommendations(tripId as string),
    enabled: Boolean(tripId),
  })
}
